import * as types from './mutation-types'

export const ActionDefinirRegistrosPorPagina = ({ commit }, registrosPorPagina) => {
  commit(types.SET_REGISTROS_POR_PAGINA, registrosPorPagina)
}
